import dayjs from 'dayjs';
import { http } from '@noor/api';
import {
  courierTransactionsSchema,
  type CourierTransactionsSearch,
} from '../model/transactions';
import type { CourierProfileId } from '../model/schema';

// Transactions are versioned gateway endpoints (`/api/v1/admin/...`).

/** Calendar dates are interpreted in Uzbekistan, independent of browser timezone. */
export function courierTransactionDateRange(filter: CourierTransactionsSearch) {
  const today = new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Asia/Tashkent',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(new Date());
  return {
    from_date: new Date(`${filter.txFrom ?? today}T00:00:00+05:00`).toISOString(),
    till_date: dayjs(`${filter.txTill ?? today}T00:00:00+05:00`)
      .add(1, 'day')
      .toISOString(),
  };
}

export const courierTransactionsApi = {
  async list(id: CourierProfileId, filter: CourierTransactionsSearch) {
    const raw = await http.get<unknown>('admin/transactions', {
      query: {
        courier_id: id,
        limit: filter.txPageSize,
        skip: (filter.txPage - 1) * filter.txPageSize,
        ...(filter.txType !== undefined ? { type: filter.txType } : {}),
        ...(filter.txStatus !== undefined ? { status: filter.txStatus } : {}),
        ...courierTransactionDateRange(filter),
      },
    });
    const result = courierTransactionsSchema.parse(raw);
    return {
      ...result,
      data: [...result.data].sort(
        (a, b) => Date.parse(b.created_at ?? '') - Date.parse(a.created_at ?? ''),
      ),
    };
  },
  async cancel(id: CourierProfileId) {
    return await http.delete<unknown>(`admin/transactions/${id}`);
  },
};
